import { useState } from "react";
import { saveCurrencyDetails } from "../Api/CurrencyMaster";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const CurrencyMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [currencyData, setCurrencyData] = useState({
    currencyCode: "",
    currencyName: "",
    symbol: "",
    isoCode: "",
    decimalPlaces: "",
    exchangeRateType: "",
    status: "",
    effectiveFromDate: "",
    country: "",
    exchangeRate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrencyData({
      ...currencyData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCurrencyDetails(currencyData, userId);
      toast.success(`🦄 Currency Added Successfully`);
      setCurrencyData({
        currencyCode: "",
        currencyName: "",
        symbol: "",
        isoCode: "",
        decimalPlaces: "",
        exchangeRateType: "",
        status: "",
        effectiveFromDate: "",
        country: "",
        exchangeRate: "",
      });
    } catch (error) {
      toast.error(
        `🦄 Error: ${error.message || "Failed to save currency details"}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container currency-master-fields">
        <h2 className="fields-title">Currency Master</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="asset-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Currency Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="currencyCode"
                        value={currencyData.currencyCode}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Currency Name <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="currencyName"
                        value={currencyData.currencyName}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Symbol <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="symbol"
                        value={currencyData.symbol}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        ISO Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="isoCode"
                        value={currencyData.isoCode}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Decimal Places <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="decimalPlaces"
                        value={currencyData.decimalPlaces}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Exchange Rate Type <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="exchangeRateType"
                        value={currencyData.exchangeRateType}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Status <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="status"
                        value={currencyData.status}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Effective From Date <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="effectiveFromDate"
                        value={currencyData.effectiveFromDate}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Country <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        value={currencyData.country}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Exchange Rate <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="exchangeRate"
                        value={currencyData.exchangeRate}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Currency
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default CurrencyMaster;
